<template>
  <AccordionV2 :title="`${t('label_option_settings')}`" v-model:is-open="isOpen">
    <div class="option">
      <div class="auto-switch-item" v-if="visibleOptions.includes('showGuestMic')">
        <p>{{ t('label_allow_guest_microphone') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch01" class="switch-input" v-model="form.options.showGuestMic" />
          <label for="switch01" class="switch"></label>
        </div>
      </div>

      <div class="auto-switch-item" v-if="visibleOptions.includes('showAttendee')">
        <p>{{ t('label_show_attendee_list_messages') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch01" class="switch-input" v-model="form.options.showAttendee" />
          <label for="switch01" class="switch"></label>
        </div>
      </div>

      <div class="auto-switch-item" v-if="visibleOptions.includes('displayVoiceRegister')">
        <p>{{ t('label_show_voice_registration_on_connect') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch01" class="switch-input" v-model="form.options.displayVoiceRegister" />
          <label for="switch01" class="switch"></label>
        </div>
      </div>

      <div class="auto-switch-item" v-if="visibleOptions.includes('screenMode')">
        <p>{{ t('label_provide_screen_mode') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch02" class="switch-input" v-model="form.options.screenMode" />
          <label for="switch02" class="switch"></label>
        </div>
      </div>

      <div class="auto-switch-item" v-if="visibleOptions.includes('subtitleMode')">
        <p>{{ t('label_provide_subtitle_mode') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch03" class="switch-input" v-model="form.options.subtitleMode" />
          <label for="switch03" class="switch"></label>
        </div>
      </div>

      <div class="auto-switch-item" v-if="visibleOptions.includes('useWithoutHost')">
        <p>{{ t('label_provide_without_host') }}</p>
        <div class="switch-btn">
          <input type="checkbox" id="switch01" class="switch-input" v-model="form.options.useWithoutHost" />
          <label for="switch01" class="switch"></label>
        </div>
      </div>
    </div>
  </AccordionV2>
</template>

<script setup lang="ts">
import AccordionV2 from '@/components/domains/mobile/common/AccordionV2.vue';
import { ChatItem } from '@/types/components';
import { CHAT_VISIBLE_OPTION_PRESETS, DEFAULT_CHAT_CREATE_FORM } from '@/utils/constants/chat';

const form = defineModel<ChatItem>('form', { default: DEFAULT_CHAT_CREATE_FORM });

const { t } = useI18n();

const isOpen = ref<boolean>(true);

const visibleOptions = computed<string[]>(() => {
  return CHAT_VISIBLE_OPTION_PRESETS[form.value.callType] || [];
});
</script>

<style scoped lang="scss">
.option {
  p {
    font-size: $font-size-psmall;
    padding-right: $size-s;
  }
  .auto-switch-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid $color-gray-40;
    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
